import { redirect } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

import { createServerFnObservabilityMiddleware } from '../utils/create-instrumented-server-fn.ts';
import { getAuthSession } from './session.server.ts';

export const getOauthCallbackPageData = createServerFn({ method: 'GET' })
	.middleware([
		createServerFnObservabilityMiddleware({
			dependencies: ['auth.session'],
			relatesTo: 'auth.oauth-callback-page',
		}),
	])
	.handler(async () => {
		const authSession = await getAuthSession(getRequest());
		if (authSession) {
			throw redirect({ href: '/portfolios' });
		}

		return null;
	});
